<div class="w-full rounded-[20px] flex justify-between py-2 px-6 border-[1px] border-border shadow-sm">
    <app-logo
        class="hover:cursor-pointer transition-transform duration-500 ease-in-out hover:scale-105 hover:-translate-y-0.5"
        height="60" width="90" (click)="goToDashboard()" title="{{ 'shared.pages.dashboard' | transloco }}"></app-logo>
    <a routerLink="/auth/logout"
        class="flex items-center rounded-md cursor-pointer hover:font-bold text-neutral-500 justify-center px-2"
        title="{{ 'shared.components.logout' | transloco }}">
        <img src="assets/icons/sidebar/logout.svg" class="h-[20px]" alt="{{ 'shared.components.logout' | transloco }}">
        <span class='pl-4 text-sm'>{{ 'shared.components.logout' | transloco }}</span>
    </a>
</div>